<template>
    <el-tabs v-model="activeName" @tab-click="tabClick" class="CompanyInfo">
        <el-tab-pane label="系统设置" name="first">

            <div style="display: flex;margin-top: 50px;margin-left: 30px;">
                <el-tooltip class="item" effect="dark" content="当采集器未发送生产信号时" placement="top">
                    <div style="width:15%;font-size: 15px;font-weight: bold;text-align:left;">{{ sysSetList[0].itemName
                        }}</div>
                </el-tooltip>
                <div style="width:15%;">
                    <el-tooltip :content="'当前状态为：' + autoPauseValue" placement="top">
                        <el-switch v-model="autoPauseValue" active-value="是" inactive-value="否"
                            @change="autoPauseChange">
                        </el-switch>
                    </el-tooltip>
                </div>
            </div>

            <div style="display: flex;margin-top: 50px;margin-left: 30px;">
                <el-tooltip class="item" effect="dark" content="采集器多久未发送生产信号，暂停设备" placement="top">
                    <div style="width:15%;font-size: 15px;font-weight: bold;text-align:left;">{{ sysSetList[1].itemName
                        }}</div>
                </el-tooltip>
                <div style="width:15%;">
                    <el-tooltip content="最短5分钟" placement="top">
                        <el-input-number v-model="pauseDuration" step-strictly :step="5" :min="5" style="width:120px"
                            @change="durationChange">
                        </el-input-number>
                    </el-tooltip>
                </div>
            </div>

            <div style="display: flex;margin-top: 50px;margin-left: 30px;">

                <div style="width:15%;font-size: 15px;font-weight: bold;text-align:left;">生产看板·列·显示</div>

                <div style="margin-left: 60px;">
                    <el-button @click="kanbanClick">更改</el-button>
                </div>


                <el-dialog title="设置·显示·隐藏" :visible.sync="dlgSwitchVisible" width="60%">

                    <div class="kb-dlg" style="display: flex;margin-bottom: 10px;">
                        <div style="width: 15%;">
                            <span>设备编号 </span>
                            <el-switch v-model="cEquipCode" :active-value="1" :inactive-value="0" @change="setC">
                            </el-switch>
                        </div>

                        <div style="width: 15%;">
                            <span>订单编号 </span>
                            <el-switch v-model="cOrderCode" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>

                        <div style="width: 15%;">
                            <span>业务代号 </span>
                            <el-switch v-model="cSalesman" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>

                        <div style="width: 15%;">
                            <span>客户 </span>
                            <el-switch v-model="cCustomer" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>

                        <div style="width: 15%;">
                            <span>产品名称 </span>
                            <el-switch v-model="cProductName" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>

                        <div style="width: 15%;">
                            <span>备注 </span>
                            <el-switch v-model="cOrderRemark" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>
                    </div>

                    <div class="kb-dlg" style="display: flex;margin-bottom: 10px;">
                        <div>
                            <span>订单数 </span>
                            <el-switch v-model="cOrderCount" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>

                        <div>
                            <span>完成数 </span>
                            <el-switch v-model="cCompleteCount" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>

                        <div>
                            <span>完成率 </span>
                            <el-switch v-model="cCompleteRate" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>

                        <div>
                            <span>首检 </span>
                            <el-switch v-model="cInspectionStatus" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>

                        <div>
                            <span>标准周期 </span>
                            <el-switch v-model="cTakeTime" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>

                        <div>
                            <span>实际周期 </span>
                            <el-switch v-model="cActualTime" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>
                    </div>

                    <div class="kb-dlg" style="display: flex;margin-bottom: 10px;">
                        <div>
                            <span>上机时间 </span>
                            <el-switch v-model="cStartTime" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>

                        <div>
                            <span>设备状态 </span>
                            <el-switch v-model="cEquipStatus" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>

                        <div>
                            <span>排队1 </span>
                            <el-switch v-model="cQueueOne" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>

                        <div>
                            <span>排队2 </span>
                            <el-switch v-model="cQueueTwo" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>

                        <div>
                            <span>排队3 </span>
                            <el-switch v-model="cQueueThree" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>

                        <div>
                            <span>剩余时间 </span>
                            <el-switch v-model="cRemainder" :active-value="1" :inactive-value="0">
                            </el-switch>
                        </div>
                    </div>

                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dlgSwitchVisible = false">取 消</el-button>
                        <el-button type="primary" @click="modifyC">保 存</el-button>
                    </div>
                </el-dialog>
            </div>



            <div>
                <div>二维码</div>
                <el-button @click="qrCodeClick">G</el-button>

                <img :src="imageUrl" alt="Dynamic Image"/>
            </div>
        </el-tab-pane>

        <el-tab-pane label="打印设置" name="fourth">
            <div>
                <div id="hello-hello">
                    <p style="display:inline;float: left;line-height: 22px;"><b>打印</b></p>
                </div>

                <el-table :data="printList" style="width: 100%" @select="selectClick" @row-click="rowClick"
                    ref="placeTable" highlight-current-row>
                    <el-table-column type="selection" width="45" label-class-name="DisabledSelection">
                    </el-table-column>

                    <el-table-column prop="tmplName" label="模版名称" min-width="9%">
                    </el-table-column>

                    <el-table-column prop="remark" label="备注" min-width="15%">
                    </el-table-column>

                    <el-table-column fixed="right" label="操作" width="100">
                        <template slot-scope="scope">
                            <el-button @click="handleClick(scope.row)" type="success" round size="small">
                                更改
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <el-dialog title="打印设置" :visible.sync="dlgFormVisible" width="60%">
                    <el-form :inline="true" :model="form" :rules="rules" ref="ruleForm">

                        <div style="display: flex;">
                            <div style="width:48%;margin-left:40px">
                                <el-form-item label="模版名称" required :label-width="formLabelWidth" prop="tmplName">
                                    <el-input v-model="form.tmplName" autocomplete="off" style="width:220px"></el-input>
                                </el-form-item>

                                <el-form-item label="公司名称" required :label-width="formLabelWidth">
                                    <el-input v-model="form.companyName" autocomplete="off"
                                        style="width:220px"></el-input>
                                </el-form-item>
                            </div>

                            <el-form-item label="公司Logo" :label-width="formLabelWidth" prop="companyLogo">
                                <el-upload class="avatar-uploader" action="#" :http-request="uploadImg"
                                    :show-file-list="false" :on-success="handleAvatarSuccess"
                                    :before-upload="beforeAvatarUpload">

                                    <img v-if="form.companyLogo" :src="'https://' + imagePath + form.companyLogo"
                                        class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>

                                </el-upload>
                            </el-form-item>
                        </div>

                        <el-form-item label="单据号前缀" required :label-width="formLabelWidth">
                            <el-input v-model="form.serialNumPre" autocomplete="off" style="width:220px"></el-input>
                        </el-form-item>
                        <div style="width:42%;display: inline-block;"></div>

                        <el-form-item label="公司地址" required :label-width="formLabelWidth">
                            <el-input v-model="form.companyAddress" autocomplete="off" style="width:570px"></el-input>
                        </el-form-item>

                        <el-form-item label="备注" :label-width="formLabelWidth">
                            <el-input v-model="form.remark" autocomplete="off" type="textarea"
                                style="width:570px"></el-input>
                        </el-form-item>
                    </el-form>

                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dlgFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="$event => addPrintSetUp('ruleForm')">保 存</el-button>
                    </div>
                </el-dialog>

            </div>
        </el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
    name: "PrintSetUp",
    data() {
        return {
            token: this.getToken(),
            companyId: this.getCompanyId(),
            userId: this.getUserId(),
            imagePath: this.getImagePath(),

            activeName: 'first',
            printList: [],
            sysSetList: [],

            autoPauseValue: '否',
            pauseDuration: 5,

            dlgFormVisible: false,

            form: {
                id: '',

                companyLogo: '',
                imgFile: {},
                tmplName: '',

                companyName: '',
                companyAddress: '',

                serialNumPre: '',

                status: 0,
                remark: '',
            },

            loading: false,
            formLabelWidth: '120px',

            dlgSwitchVisible: false,
            kanbanSetId: '',
            cEquipCode: 1,
            cOrderCode: 1,
            cSalesman: 1,
            cCustomer: 1,
            cProductName: 1,
            cOrderRemark: 1,

            cOrderCount: 1,
            cCompleteCount: 1,
            cCompleteRate: 1,
            cInspectionStatus: 1,
            cTakeTime: 1,
            cActualTime: 1,

            cStartTime: 1,
            cEquipStatus: 1,
            cQueueOne: 1,

            cQueueTwo: 1,
            cQueueThree: 1,
            cRemainder: 1,

            rules: {
                tmplName: [
                    { required: true, message: '请输入模版名称', trigger: 'blur' },
                    { required: true, message: '请输入模版名称', trigger: 'change' }
                ]
            },

            imageUrl:''
        }
    },
    methods: {
        qrCodeClick() {

            this.$axios({
                method: "get",
                url: "/shiro/p/code",
                data: {
                    
                },
                headers: {
                    token: this.token,
                },
            }).then((result) => {

                const data = result.data

                console.log(data)

                // const blob = new Blob([data], {
                //     type: 'image/jpeg;'
                // })

                this.imageUrl ='https://www.jzxmes.cn/shiro/p/code'

                // this.imageUrl = URL.createObjectURL(blob)

                // const a = document.createElement("a")
                // a.href = this.imageUrl

                // a.download = 'qr.jpg'
                // a.click()
                // a.remove()
                // URL.revokeObjectURL(this.imageUrl)

                
            })

            // const appId = 'wx39c6a958101d1fef'
            // const secret = 'eb54d3732df9ea51b3e65589c295ec1c'

            // const axios = require('axios')

            // axios.get(`https://api.weixin.qq.com/cgi-bin/token?grant_type=client_credential&appid=${appId}&secret=${secret}`)
            //     .then(response => {

            //         console.log(response.data)
            //     })


            // const access_token = '你的小程序ACCESS_TOKEN' // 通过appid和secret获取
            // const data = {
            //     path: 'pages/parking/parking',
            //     width: 430 // 二维码宽度（像素）
            // }

            // axios.post(`https://api.weixin.qq.com/wxa/getwxacode?access_token=${access_token}`, data, { responseType: 'arraybuffer' })
            //     .then(response => {

            //         // 将返回的二进制图片保存为二维码
            //         // fs.writeFileSync('qrcode.png', response.data)
            //     })


        },
        modifyC() {
            console.log('cc')
            console.log(this.cEquipCode)
            console.log(this.cOrderCode)
            console.log(this.cSalesman)

            this.$axios({
                method: "post",
                url: "/shiro/product/kanban/mSet",
                data: {
                    companyId: this.companyId,
                    id: this.kanbanSetId,

                    equipCodeC: this.cEquipCode,
                    orderCodeC: this.cOrderCode,
                    salesmanC: this.cSalesman,

                    customerC: this.cCustomer,
                    productNameC: this.cProductName,
                    orderRemarkC: this.cOrderRemark,

                    orderCountC: this.cOrderCount,
                    completeCountC: this.cCompleteCount,
                    completeRateC: this.cCompleteRate,
                    inspectionStatusC: this.cInspectionStatus,
                    takeTimeC: this.cTakeTime,
                    actualTimeC: this.cActualTime,

                    startTimeC: this.cStartTime,
                    equipStatusC: this.cEquipStatus,
                    queueOneC: this.cQueueOne,

                    queueTwoC: this.cQueueTwo,
                    queueThreeC: this.cQueueThree,
                    remainderC: this.cRemainder
                },
                headers: {
                    token: this.token,
                },
            }).then((result) => {

                const data = result.data

                this.dlgSwitchVisible = false
            })
        },
        kanbanClick() {

            this.$axios({
                method: "post",
                url: "/shiro/product/kanban/getSet",
                data: {
                    companyId: this.companyId,
                    userId: this.userId
                },
                headers: {
                    token: this.token,
                },
            }).then((result) => {

                const data = result.data

                if (data.data != null) {

                    this.kanbanSetId = data.data.id

                    this.cEquipCode = data.data.equipCodeC
                    this.cOrderCode = data.data.orderCodeC
                    this.cSalesman = data.data.salesmanC


                    this.cCustomer = data.data.customerC
                    this.cProductName = data.data.productNameC
                    this.cOrderRemark = data.data.orderRemarkC

                    this.cOrderCount = data.data.orderCountC
                    this.cCompleteCount = data.data.completeCountC
                    this.cCompleteRate = data.data.completeRateC
                    this.cInspectionStatus = data.data.inspectionStatusC
                    this.cTakeTime = data.data.takeTimeC
                    this.cActualTime = data.data.actualTimeC

                    this.cStartTime = data.data.startTimeC
                    this.cEquipStatus = data.data.equipStatusC
                    this.cQueueOne = data.data.queueOneC

                    this.cQueueTwo = data.data.queueTwoC
                    this.cQueueThree = data.data.queueThreeC
                    this.cRemainder = data.data.remainderC

                }

                this.dlgSwitchVisible = true
            })
        },
        autoPauseChange(val) {

            this.$axios({
                method: "post",
                url: "/shiro/sys/set/modify",
                data: {
                    companyId: this.companyId,
                    id: this.sysSetList[0].id,
                    itemContent: val == '是' ? '1' : '0'
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })

                    this.autoPauseValue = val == '是' ? '否' : '是'
                    return
                }

            })
        },
        durationChange(val) {

            this.$axios({
                method: "post",
                url: "/shiro/sys/set/modify",
                data: {
                    companyId: this.companyId,
                    id: this.sysSetList[1].id,
                    itemContent: val
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.$message({
                    type: 'info',
                    message: data.msg
                })
            })
        },
        getAllSysSet() {

            this.$axios({
                method: "post",
                url: "/shiro/sys/set/getAll",
                data: {
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.sysSetList = data.data

                this.autoPauseValue = this.sysSetList[0].itemContent == '0' ? '否' : '是'

                this.pauseDuration = this.sysSetList[1].itemContent

                // console.log(this.pauseDuration)
            })
        },
        uploadImg(f) {
            this.form.imgFile = f.file
        },
        selectClick(selection, row) {

            this.$refs.placeTable.clearSelection()
            this.$refs.placeTable.toggleRowSelection(row)

            this.form.id = row.id
        },
        rowClick(row) {

            this.$refs.placeTable.clearSelection()
            this.$refs.placeTable.toggleRowSelection(row)

            this.form.id = row.id
        },
        handleClick(row) {

            this.form.id = row.id

            this.form.companyLogo = row.companyLogo

            this.form.tmplName = row.tmplName

            this.form.companyName = row.companyName
            this.form.companyAddress = row.companyAddress

            this.form.serialNumPre = row.serialNumPre

            this.form.status = row.status
            this.form.remark = row.remark

            this.dlgFormVisible = true
        },
        addPrintSetUp(formName) {

            this.$refs[formName].validate((valid) => {
                if (valid) {

                    const form = new FormData()

                    form.append('id', this.form.id)

                    form.append('tmplName', this.form.tmplName)
                    form.append('companyName', this.form.companyName)

                    form.append('companyAddress', this.form.companyAddress)
                    form.append('serialNumPre', this.form.serialNumPre)

                    form.append('remark', this.form.remark)

                    form.append('companyId', this.companyId)

                    // console.log('this.form.imgFile')
                    // console.log(this.form.imgFile)

                    let arr = Object.keys(this.form.imgFile)
                    if (arr.length == 0) {
                        // console.log('000')
                        form.append('logoFile', new File([], 'file'))
                    } else {
                        form.append('logoFile', this.form.imgFile)
                    }

                    this.$axios({
                        method: "post",
                        url: "/shiro/print/set/add",
                        data: form,
                        headers: {
                            token: this.token
                        }
                    }).then(result => {

                        const data = result.data

                        if (data.status != 200) {
                            this.$message(data.msg)
                            return
                        }

                        this.dlgFormVisible = false

                        this.getAllPrint()
                    })
                } else {
                    return false
                }
            })
        },
        getAllPrint() {

            this.$axios({
                method: "post",
                url: "/shiro/print/set/getAll",
                data: {
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                if (data.status === 400) {
                    this.$router.push({ path: "/Login" })
                }

                if (data.status === 202) {
                    this.$notify({
                        title: '重要提示',
                        message: data.msg,
                        duration: 0
                    })
                    return
                }

                if (data.status != 200) {
                    this.$message({
                        type: 'info',
                        message: data.msg
                    })
                    return
                }

                this.printList = data.data

            })
        }
    },
    mounted() {

        this.getAllSysSet()
    },
    updated() {

    }
}
</script>

<style>
.el-badge {
    position: relative;
    vertical-align: middle;
    display: inline-block;
}

.radio-sup {
    border-radius: 8px;
    color: #fff;
    display: inline-block;
    font-size: 13px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
    background-color: red;

    position: absolute;
    top: -10px;
    right: 60%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar {
    width: 150px;
    height: 150px;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 118px;
    height: 118px;
    line-height: 118px;
    text-align: center;
}

#create_work {
    position: relative;
    right: 5px;
    width: 120px;
}

.DisabledSelection .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-pagination__total {
    color: green;
}

.kb-dlg>div {
    width: 15%;
    text-align: right;
}
</style>